<script>
import Static from "@/views/Static.vue";

export default {
    name: "Terms",
    extends: Static
};
</script>
